<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import {
  getUserInfo,
  getAppVerInfo,
  setupWebViewJavascriptBridge,
} from "@/assets/js/client.js";
import { testPlatform } from "@/utils";

export default {
  name: "app",
  data() {
    return {
      loadCount: 0,
    };
  },
  created() {
    let that = this;
    if (testPlatform("ios")) {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler("getCurrentUserToken", null, function (data) {
          that.$store.commit("setMemberInfo", data);
          that.$store.commit("setQuery", data);
          console.log("app memberinfo", data);
        });
        bridge.callHandler("getAppVer", null, function (data) {
          that.$store.commit("setVer", { ver: data, verName: data });
          try {
            console.log("app ver", data, parseInt(data.replace(/\./g, "")));
          } catch (err) {
            console.log(err);
          }
        });
      });
    } else {
      this.androidMethod();
    }
  },
  methods: {
    androidMethod() {
      console.log("create count:", this.loadCount);
      if (window.hsj) {
        let _userInfo = getUserInfo();
        let _version = getAppVerInfo();
        console.log("android _userInfo", typeof _userInfo, _userInfo);
        console.log("android _version", typeof _version, _version);
        if (_version) {
          let info = JSON.parse(_userInfo);
          let ver = JSON.parse(_version);
          this.$store.commit("setMemberInfo", info);
          this.$store.commit("setQuery", info);
          this.$store.commit("setVer", { ver: ver, verName: ver.verName }); // "verCode":89,"verName":"1.6.2"
        }
        if (window.hsj.getMargins) {
          const marginInfo = window.hsj.getMargins();
          if (marginInfo) {
            this.setMargins(JSON.parse(marginInfo));
          }
        }
      } else {
        if (this.loadCount < 5) {
          setTimeout(() => {
            this.loadCount++;
            this.androidMethod();
            console.log("load times", this.loadCount);
          }, 200);
        }
      }
    },
    setMargins(params) {
      const topMargin = params?.topMargin || 0;
      const bottomMargin = params?.bottomMargin || 0;
      document.documentElement.style?.setProperty('--safe-area-inset-top', `${topMargin / window.devicePixelRatio}px`);
      document.documentElement.style?.setProperty('--safe-area-inset-bottom', `${bottomMargin / window.devicePixelRatio}px`);
      
      document.querySelector('meta[name="viewport"]').setAttribute('content', "width=device-width,user-scalable=no,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0,viewport-fit=cover");

      document.body.style.backgroundColor="#FFFFFF";
    },
    userInfoCb(_userInfo) {
      let info = JSON.parse(_userInfo);
      info.appVer = "";
      console.log("userInfoCb", info);
      this.$store.commit("setMemberInfo", info);
      this.$store.commit("setQuery", info);
    },
    versionCb(_version) {
      console.log("versionCb org", _version);
      let ver = JSON.parse(_version);
      console.log("versionCb", ver);
      this.$store.commit("setVer", ver); // "verCode":89,"verName":"1.6.2"
    },
  },
};
</script>
<style></style>
